import { readonly, ref } from 'vue';

// Complement of Tailwind's lg breakpoint (min-width: 1024px): the 0.02px gap
// prevents mobile and desktop styles from both matching at exactly 1024px.
const MOBILE_MEDIA_QUERY = '(max-width: 1023.98px)';

const isMobile = ref(false);
let mediaQueryBound = false;

export const useIsMobile = () => {
    if (import.meta.client && !mediaQueryBound) {
        mediaQueryBound = true;
        const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
        isMobile.value = mediaQuery.matches;
        mediaQuery.addEventListener('change', (event) => {
            isMobile.value = event.matches;
        });
    }

    return { isMobile: readonly(isMobile) };
};
